import { z } from "zod";

export const PaymentIntegrationTypeSchema = z.enum([
  "payrexx",
  "payrexx_softpos",
  "stripe",
  "nakka",
  "tiblisi_bank",
  "wallee",
]);

export type PaymentIntegrationType = z.infer<
  typeof PaymentIntegrationTypeSchema
>;

export const PaymentIntegrationUsageTypeSchema = z.enum([
  "online",
  "tap2pay",
  "terminal",
]);

export type PaymentIntegrationUsageType = z.infer<
  typeof PaymentIntegrationUsageTypeSchema
>;

export interface PayrexxCredentials {
  instance_name: string;
  api_key: string;
}

export interface PayrexxSettings {
  type?: PaymentIntegrationUsageType;
  is_external: boolean;
}

export interface PayrexxSoftPOSCredentials {
  api_key: string;
}

export interface StripeCredentials {
  api_key: string;
}

export interface NakkaCredentials {
  password: string;
}

export interface NakkaSettings {
  type?: PaymentIntegrationUsageType;
  name: string;
  user_ids: number[];
}

export interface TiblisiBankCredentials {
  merchant_id: string | number;
  signature?: string;
  api_key?: string;
  api_base_url?: string;
}

export interface GenericPaymentIntegrationSettings {
  type?: PaymentIntegrationUsageType;
}

export interface WalleeCredentials {
  user_id: string;
  api_key?: string;
  api_secret?: string;
  space_id: string | number;
  terminal_id: string | number;
  api_host?: string;
}

export type PaymentIntegrationCredentials =
  | PayrexxCredentials
  | PayrexxSoftPOSCredentials
  | StripeCredentials
  | NakkaCredentials
  | TiblisiBankCredentials
  | WalleeCredentials;

export type PaymentIntegrationSettings =
  | PayrexxSettings
  | NakkaSettings
  | GenericPaymentIntegrationSettings
  | Record<string, unknown>;

export interface PaymentIntegration {
  id: string;
  type: PaymentIntegrationType;
  restaurant_id: number;
  credentials: PaymentIntegrationCredentials;
  settings: PaymentIntegrationSettings;
  user_ids: number[];
  created_at: string;
  updated_at: string;
}

export type SessionPaymentIntegration = Omit<PaymentIntegration, "credentials">;

export interface CreatePaymentIntegrationData {
  type: PaymentIntegrationType;
  credentials: PaymentIntegrationCredentials;
  settings: PaymentIntegrationSettings;
  user_ids: number[];
}

export interface UpdatePaymentIntegrationData {
  type?: PaymentIntegrationType;
  credentials?: PaymentIntegrationCredentials;
  settings?: PaymentIntegrationSettings;
  user_ids?: number[];
}

export interface PaymentIntegrationFilters {
  type?: PaymentIntegrationType;
}
